import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { Form } from 'react-bootstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { getApi, postApi } from "../../Helpers/Axios";
import { useSelector } from 'react-redux';

const Addform = () => {
    const navigate = useNavigate();
    const admin = useSelector((state) => state?.auth?.user);
    let [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get('edit_id')) {
            handleEdit()
        }
    }, [searchParams.get('edit_id')])

    const handleEdit = async () => {
        let url = `get-villages?edit_id=${searchParams.get('edit_id')}`;
        await getApi(url, true).then((response) => {
            if (response.status === 200) {
                setInitialValueData(response.data)
            }
        })
    }

    const [initialValues, setInitialValueData] = useState({
        name_eng: null,
        name_gj: null,
        status: 1,
    });

    const validationSchema = Yup.object({
        name_eng: Yup.string()
            .required("Village english is required."),
        name_gj: Yup.string()
            .required("Village gujrati is required.")
    });

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            values.status = values.status ? 1 : 0;
            let url = searchParams.get('edit_id') ? `add-edit-village?edit_id=${searchParams.get('edit_id')}` : 'add-edit-village';
            await postApi(url, values, true)
                .then((response) => {
                    if (response.status === 200) {
                        navigate("/villages");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    });

    return (
        <div>
            <div>
                <div>
                    <p className='breadcrumbs'><Link to='/dashboard'><span>Dashboard</span></Link> / <Link to='/villages'><span>Village</span></Link> / <span>Add</span></p>
                </div>
            </div>
            <div>
                <form method='post' className='add-detail-main' onSubmit={handleSubmit} encType='multipart/form-data'>
                    <div class="form-with-lable">
                        <label class="mt-1 form_label">Village english</label>
                        <div class="input-box">
                            <input type='text' placeholder='Enter Village english' name='name_eng' onChange={handleChange} onBlur={handleBlur} value={values?.name_eng} />
                        </div>
                    </div>
                    {(errors?.name_eng && touched?.name_eng) ? <span className='require-text'>{errors?.name_eng}</span> : null}
                    <div class="form-with-lable mt-3">
                        <label class="form_label">Village gujrati</label>
                        <div class="input-box">
                            <input type='text' placeholder='Enter Village gujrati' name='name_gj' onChange={handleChange} onBlur={handleBlur} value={values?.name_gj} />
                        </div>
                    </div>
                    {(errors?.name_gj && touched?.name_gj) ? <span className='require-text'>{errors?.name_gj}</span> : null}
                    <Form.Check
                        type="switch" id="custom-switch"
                        label="Status" className='float-end mt-2'
                        checked={values?.status} onChange={(e) => setFieldValue('status', !values?.status)}
                    />
                    <div className='text-center mt-4'>
                        <button type='submit' className='theme-btn px-4'>Submit</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Addform